import { getProviderSectionDetails } from 'app/ProviderDetails/utils'
import { ReactElement } from 'react'
import Select from 'react-select'
import styles from './index.module.scss'
import { customStyles } from './styles'
import { CounselingTypeEnum } from 'app/Bookings/constants'
import { getServiceTypeDisplayLabel } from 'app/ProviderSearch/ProviderFilter/CounselingFilter/constants'

interface AppointmentDropdownProps {
  handleCounselingSelection: (selection: {
    label: string
    value: string
  }) => void
  counselingSelection: { label: string; value: string }
  providerDetails: Provider
  isEnabled?: boolean
}

const AppointmentDropdown = ({
  counselingSelection,
  handleCounselingSelection,
  providerDetails,
  isEnabled = true,
}: AppointmentDropdownProps): ReactElement => {
  const { id: providerId } = providerDetails
  const { populationServed } = getProviderSectionDetails(providerDetails)
  const isSingleServiceTypeSupported = populationServed?.length === 1

  const handleOnChange = (selected: SelectItem | null): void => {
    if (selected == null) {
      return
    }

    const updatedCounselingTypeSelected = updateCounselingTypeSelected(selected)

    if (
      updatedCounselingTypeSelected &&
      updatedCounselingTypeSelected.value !== counselingSelection.value
    ) {
      handleCounselingSelection(updatedCounselingTypeSelected)
    }
  }

  const updateCounselingTypeSelected = (selection: {
    value: string
    id?: string
  }): SelectItem => {
    if (selection.value === undefined) {
      return null
    }

    const counselingTypeObject = populationServed.find((type) => {
      return selection?.value
        ? type.id === selection.value
        : type.value === CounselingTypeEnum.INDIVIDUAL // default
    })

    if (!counselingTypeObject) {
      return null
    }

    return {
      label: counselingTypeObject.value,
      value: counselingTypeObject.id,
    }
  }

  return (
    <div className={styles.counseling_type_typography}>
      {!isSingleServiceTypeSupported && (
        <div
          id={`provider_services_dropdown-${providerId}`}
          className={styles.counseling_header_text}
        >
          What type of therapy would you like?
        </div>
      )}
      <div className={styles.service_type_container}>
        {isSingleServiceTypeSupported ? (
          <div className={styles.single_service_type_text}>
            {getServiceTypeDisplayLabel(populationServed[0].value)}
          </div>
        ) : (
          <Select
            aria-labelledby={`provider_services_dropdown-${providerId}`}
            defaultValue={updateCounselingTypeSelected({
              value: counselingSelection.value,
            })}
            onChange={(selected) => handleOnChange(selected)}
            options={populationServed.map((counselingType) => ({
              label: counselingType.value,
              value: counselingType.id,
            }))}
            getOptionLabel={(option) =>
              getServiceTypeDisplayLabel(option.label)
            }
            styles={customStyles}
            placeholder="Select..."
            isDisabled={!isEnabled}
          />
        )}
      </div>
    </div>
  )
}

export default AppointmentDropdown
